import { FeatureContext, featureOperations, Features } from '@ardoq/features';

export const isUsageMetricsEnabled = (
  featureContext: FeatureContext
): boolean =>
  !featureOperations.hasFeature(
    featureContext,
    Features.DASHBOARDS_RESTRICTED_DISABLE_USAGE_METRICS
  );
